import { useState } from "react";
const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;

const initialStatebox = {
  ejercicioinicio: ejercicioActual,
  periodoinicio: 1,
  ejerciciofin: ejercicioActual,
  ejercicio: ejercicioActual,
  periodofin: mesActual,
  periodo: mesActual,
  mesfin: mesActual,
  titulosucursal: "",
  titulodepartamento: "",
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
